
<div *ngIf="onlineStatus === 'online'" >
  <div class="alert alert-success alert-dismissible fade show" role="success" style="width: 100;text-align: center;">
    <p  class="text-success"><i class="fas fa-wifi"></i> {{onlineStatusMessage}}</p>
    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
  </div>
</div>

<div *ngIf="onlineStatus === 'offline'" >
  <div class="alert alert-danger " role="alert" style="width: 100;text-align: center;">
    <p class="text-danger"><i class="fas fa-wifi-slash"></i> {{onlineStatusMessage}}</p>
  </div>
</div>
